import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./app.css";
import "./fonts.css";
import Router from "./Router";
import store from "./store";
import { themeTokens } from "./theme";

function App() {
  let theme = createTheme(themeTokens);
  theme = responsiveFontSizes(theme);
  const queryClient = new QueryClient();

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <Router />
          </QueryClientProvider>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
